type ButtonVariant = "primary" | "secondary" | "danger" | "outline" | "ghost";

export default function Button({
  children,
  onClick = undefined,
  disabled = false,
  submit = false,
  variant = "primary",
  className = "",
}: {
  children: any;
  onClick?: any;
  disabled?: boolean;
  submit?: boolean;
  variant?: ButtonVariant;
  className?: string;
}) {
  const baseClasses =
    "px-6 py-2.5 cursor-pointer rounded-full font-semibold transition-all duration-300 flex items-center justify-center gap-2 text-sm ";

  const variants: Record<ButtonVariant, string> = {
    primary:
      "bg-[#0071e3] text-white hover:bg-[#0077ed] shadow-sm active:scale-[0.98]",
    secondary:
      "bg-[#e8e8ed] text-[#1d1d1f] hover:bg-[#d2d2d7] active:scale-[0.98]",
    danger:
      "bg-[#ff3b30]/10 text-[#ff3b30] hover:bg-[#ff3b30] hover:text-white active:scale-[0.98]",
    outline:
      "border border-[#0071e3] bg-transparent text-[#0071e3] hover:bg-[#0071e3]/5 active:scale-[0.98]",
    ghost:
      "bg-transparent text-[#0071e3] hover:bg-[#0071e3]/5 active:scale-[0.98]",
  };

  const disabledClasses =
    "opacity-50 cursor-not-allowed pointer-events-none grayscale";

  const buttonClasses = `${baseClasses} ${variants[variant]} ${disabled ? disabledClasses : "cursor-pointer"} ${className}`;

  return (
    <button
      type={submit ? "submit" : "button"}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={buttonClasses}
      aria-disabled={disabled}
    >
      {children}
    </button>
  );
}
